import React from 'react';
import PropTypes from 'prop-types';

import PopOverMenu from '../../../PopOverMenu';

const options = {
    CALL: 'call',
    TEXT: 'text',
    EMAIL: 'email',
    MESSAGE: 'message',
};

const MessagePopover = props => {
    const { email, phone, onMessageClick } = props;
    const menuOptions = [];

    if (phone) {
        menuOptions.push({ label: `Call ${phone}`, value: options.CALL });
        menuOptions.push({ label: `Text ${phone}`, value: options.TEXT });
    }
    if (email) {
        menuOptions.push({ label: `Email ${email}`, value: options.EMAIL });
    }
    menuOptions.push({ label: 'Message on platform', value: options.MESSAGE });

    const onMenuSelected = (selected, e) => {
        e.stopPropagation();
        e.preventDefault();

        if (selected.value === options.CALL) {
            window.open(`tel:${phone}`);
        }
        if (selected.value === options.TEXT) {
            window.open(`sms:${phone}`);
        }
        if (selected.value === options.EMAIL) {
            window.open(`mailto:${email}`);
        }
        if (selected.value === options.MESSAGE) {
            onMessageClick();
        }
    };

    return (
        <PopOverMenu
            horizontalEllipsis={false}
            menuItems={menuOptions}
            onSelected={onMenuSelected}
            anchorClass="ml0 d-flex aic"
        >
            <div className="click-area click-area-24">
                <i className={`utr utr-message fs18 text-teal`} />
            </div>
            <i className="fas fa-solid fa-caret-down text-teal fs14" />
        </PopOverMenu>
    );
};

MessagePopover.propTypes = {
    email: PropTypes.string,
    phone: PropTypes.string,
    onMessageClick: PropTypes.func,
};
MessagePopover.defaultProps = {
    email: null,
    phone: null,
    onMessageClick: () => {},
};

export default MessagePopover;
